import styled from 'styled-components';

export const StyledShipmentAnalytics = styled.div`
  width: 100%;

  .Polaris-Header-Title__TitleMetadata {
    flex: 1;
  }
`;
